import { optionSchema } from "@/common/schemas/option.schema"
import { z } from "zod"

export const createSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  operation_klass: optionSchema,
  description: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  properties: z
    .string()
    .optional()
    .nullable()
    .refine((value) => {
      if (!value) return true
      try {
        const parsed = JSON.parse(value.replace(/'/g, '"'))
        return Object.prototype.toString.call(parsed) === '[object Object]'
      } catch {
        return false
      }
    }, {
      message: "Formato de JSON inválido",
    }),
})

export const updateSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  description: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
})

export type UpdatePermissionValidationSchema = z.infer<typeof updateSchema>
export type PermissionValidationSchema = z.infer<typeof createSchema>
